import * as yup from 'yup'
import { PlanInterval } from '@dtx-company/true-common/src/types/PlanInterval'
import { PlanPurchaseFormProps } from '../../PlanPurchaseFormProps'
import { displayPaymentMethodAddressFields } from '@app/common/src/components/PlanPurchaseExperience/constants'
import { isOrgPlan } from '@app/common/src/utils/isOrgPlan'
import { useMemo } from 'react'

/**
 * FOR INTERNAL USE
 *
 * Provides the validation schema for the PlanPurchaseForm, using custom
 * error messages provided by Prismic
 */
export function usePlanPurchaseFormSchema(
  validationErrors: PlanPurchaseFormProps['validationErrors'],
  existingPaymentMethod?: PlanPurchaseFormProps['existingPaymentMethod'],
  paymentType?: string
): yup.ObjectSchema<{
  paymentElementComplete?: boolean
  planInterval?: PlanInterval
  orgName?: string
  billingDetails: object
}> {
  return useMemo(() => {
    return yup.object({
      paymentElementComplete: yup.bool().when('existingPaymentMethod', () => {
        if (!existingPaymentMethod)
          return yup
            .bool()
            .test('is-true', 'Please fill out the missing information above', x => x === true)
        else return yup.boolean()
      }),
      planInterval: yup
        .string()
        .oneOf([PlanInterval.MONTHLY, PlanInterval.YEARLY])
        .required(validationErrors?.planIntervalRequired),
      billingDetails: yup.object().test({
        message: 'Please fill out the missing information above',
        test: (value: any) => {
          if (paymentType && displayPaymentMethodAddressFields.includes(paymentType)) {
            return !!value?.name && !!value?.address && !!value.address.postal_code
          } else {
            return true
          }
        }
      }),
      orgName: yup.string().when('$planType', (planType: any) => {
        if (planType && isOrgPlan(planType))
          return yup
            .string()
            .required(validationErrors?.orgNameRequired)
            .min(3, validationErrors?.orgNameMinMaxLength)
            .max(64, validationErrors?.orgNameMinMaxLength)
        else return yup.string().notRequired()
      })
    })
  }, [validationErrors, existingPaymentMethod, paymentType])
}
